export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6497.872371f4.jpg";